import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeamUsersRequest } from "store/user/reducer";
import { userSelector } from "store/user/selector";
import Collaborators from "./Collaborators";

export default function IndividualTeam() {
  const user = useSelector(userSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!user?.user_id) return;
    dispatch(
      fetchTeamUsersRequest({
        user_id: user.user_id,
      })
    );
  }, [dispatch, user?.user_id]);
  return (
    <Flex direction="column">
      <Collaborators />
    </Flex>
  );
}
